import { Injectable } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { IAlgoStrategyPromiseLookupService } from "../IAlgoStrategyPromiseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class AlgoStrategyPromiseLookupService
  extends PromiseLookupService<string, CubiqTS.AlgoStrategyImpl>
  implements IAlgoStrategyPromiseLookupService
{
  constructor() {
    super();
  }

  abstract getAlgoStrategy(id: string): Promise<CubiqTS.AlgoStrategyImpl>;
  abstract getAllIds(): Promise<Array<string>>;
}
